import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { Member } from '@/lib/use-session';

export interface RouterContext {
  queryClient: QueryClient;
  member: Member | null;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="page-root">
      <Outlet />
    </div>
  );
}
